import black_icon from "../../assets/czj.png";
import white_icon from "../../assets/czj-white.png";

import classes from "./VideoButton.module.css";

interface VideoButtonInterface {
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
    white?: boolean;
    width?: string;
    style?: React.CSSProperties;
}

const VideoButton = ({ setModal, white, width, style }: VideoButtonInterface) => {
    return (
        <img
            src={white ? white_icon : black_icon}
            alt="img"
            className={classes.videoButton}
            onClick={() => setModal(true)}
            style={width ? { width: width, ...style } : { ...style }}
        />
    );
};

export default VideoButton;
